import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqSection = ({ faq, titulo = "Perguntas Frequentes" }) => (
  <section className="my-12" data-testid="faq-section">
    <h2 className="font-heading font-black text-2xl md:text-3xl text-brand-dark uppercase tracking-tight mb-6">{titulo}</h2>
    <Accordion type="single" collapsible className="w-full">
      {faq.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="text-left font-heading font-bold text-brand-dark hover:text-brand-red text-sm md:text-base">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-gray-600 text-sm md:text-base leading-relaxed">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
